import { useCallback, useEffect, useRef } from 'react';

type UseMounted = () => () => boolean;

const useMounted: UseMounted = () => {
  const ref = useRef(false);

  useEffect(() => {
    ref.current = true;

    return () => {
      ref.current = false;
    };
  });

  return useCallback(() => ref.current, []);
};

export { useMounted };
export default useMounted;